export default __webpack_public_path__ + "static/media/importGeneric.0f5b4e17.svg";